export default {
  namespaced: true,
  state: () => ({
    accountUuid: null,
    unit: null,
    channelId: null,
  }),
  getters: {
    getAccountUuid: (state) => state.accountUuid,
    getUnit: (state) => state.unit,
    getChannelId: (state) => state.channelId,
  },
  mutations: {
    setAccountUuid: (state, accountUuid) => {
      state.accountUuid = accountUuid
    },
    setUnit: (state, unit) => {
      state.unit = unit
    },
    setChannelId: (state, channelId) => {
      state.channelId = channelId
    },
  },
  actions: {
    openChatPopup({ commit }, { accountUuid, unit, channelId }) {
      commit('setAccountUuid', accountUuid)
      commit('setUnit', unit)
      commit('setChannelId', channelId)
      commit('general/toggleShowModal', { chatPopup: true }, { root: true })
    },
    closeChatPopup({ commit }) {
      commit('setAccountUuid', null)
      commit('setUnit', null)
      commit('setChannelId', null)
      commit('general/toggleShowModal', { chatPopup: false }, { root: true })
    },
  },
}
